/**
 * Price ticker display — jQuery Counter animation + formatPricing
 * (REQ-PRICE-2/3; research/04 §3.2, §3.3, §7.18).
 *
 * The animation is QUEUED (no .stop()): rapid changes stack 200 ms tweens
 * and the display lags the real price (PRICE-002 pins this). jQuery
 * .animate() runs one synchronous zero-progress step (the OLD value) before
 * returning (ERRATA #12). Every step defers to Nova's
 * HasPriceTickerFormattedWithNovaCurrency claim check.
 *
 * formatPricing moved here from common/common-utils.ts (its SPEC §2.1 home);
 * no currency symbol, grouping regex /\B(?=(\d{3})+(?!\d))/g, decimals from
 * appState.priceMarkerDecimals unless overrideDecimalsTo2.
 */
import { appState } from "../state/app-state";
import { HasPriceTickerFormattedWithNovaCurrency } from "../currency";
import {
  IsNativeCurrencyActive,
  ConvertToActive,
  FormatActive,
} from "../currency/native-simple";
import $ from "jquery";

export function formatPricing(
  number: any,
  thousandSep: any,
  decimalSep: any,
  overrideDecimalsTo2 = false,
): string {
  let thousandSeparator;
  if (thousandSep === 1) {
    thousandSeparator = ",";
  } else if (thousandSep === 2) {
    thousandSeparator = ".";
  } else if (thousandSep === 3) {
    thousandSeparator = " ";
  } else {
    thousandSeparator = "";
  }

  // Define the decimal separator
  const decimalSeparatorStr = decimalSep === 1 ? "," : ".";

  // Split the number into integer and decimal parts
  const parts = number
    .toFixed(overrideDecimalsTo2 ? 2 : appState.priceMarkerDecimals)
    .split(".");

  // Format the integer part with thousand separator
  let formattedInteger = parts[0].replace(
    /\B(?=(\d{3})+(?!\d))/g,
    thousandSeparator,
  );

  // Combine the integer and decimal parts with the decimal separator
  const formattedNumber =
    formattedInteger + (parts.length > 1 ? decimalSeparatorStr + parts[1] : "");

  return formattedNumber;
}

/**
 * Start the queued #priceTicker tween FROM appState.cpc_currentPrice TO
 * finalValue. Caller (UpdatePrice) updates cpc_currentPrice AFTER this
 * returns, exactly as v1 ordered the statements — the synchronous
 * zero-progress first step therefore still sees the old price.
 */
export function animatePriceTicker(finalValue: any): void {
  //document.getElementById('priceTicker').innerHTML = jj;
  $("#priceTicker")
    .prop("Counter", appState.cpc_currentPrice)
    .animate(
      {
        Counter: finalValue,
      },
      {
        duration: 200,
        easing: "swing",
        step: function (this: any, now: any) {
          // Native currency v1 (#chunk3): when the merchant opted in and the
          // shopper is in a non-base currency, convert client-side via
          // window.Shopify.currency and let Intl format the frame value (symbol +
          // grouping + per-currency decimals). price-marker.ts renders the
          // #priceTicker element in native mode with NO merchant Prefix and NO
          // <suffix> sibling, so setting its html to the Intl value is the whole
          // display — neither the merchant Prefix/Suffix nor formatPricing's
          // separators ever apply. Follow-ups (out of v1 scope): calculation
          // sub-elements and the cart page are NOT converted here.
          if (IsNativeCurrencyActive()) {
            $(this).html(FormatActive(ConvertToActive(Number(now))));
            return;
          }
          const formattedNumber = formatPricing(
            Number(now),
            +appState.cpc_configData.thousandSeperator,
            +appState.cpc_configData.decimalSeperator,
          );
          if (!HasPriceTickerFormattedWithNovaCurrency(Number(now), "#priceTicker")) {
            $(this).html(
              formattedNumber,
            );
          }
        },
      },
    );
}
